import {
  getRegisteredShapeCategory,
  type RegisteredShapeCategory,
} from './shapeCategoryRegistry';
import { getShapeManifest, type DiagramType } from './registries';

export interface ResolvedShapeCategoryManifest {
  category: RegisteredShapeCategory;
  diagramType: DiagramType;
  manifest: NonNullable<ReturnType<typeof getShapeManifest>>;
}

export function resolveRegisteredShapeCategoryManifest(
  categoryId: string | undefined,
  shapeId: string | undefined,
): ResolvedShapeCategoryManifest | undefined {
  if (!categoryId || !shapeId) return undefined;

  const category = getRegisteredShapeCategory(categoryId);
  if (!category) return undefined;

  for (const diagramType of category.applicableDiagramTypes) {
    const manifest = getShapeManifest(diagramType, shapeId);
    if (manifest) {
      return { category, diagramType, manifest };
    }
  }

  return undefined;
}
